var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-subheader',{staticClass:"font-weight-bold primary--text",staticStyle:{"font-size":"large"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }